var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"colorado-sounds"}},[_c('h1',[_vm._v("WAS ICH SAH UND HöRTE")]),_c('div',{staticClass:"content-wrapper"},[_c('img',{staticClass:"img-1",attrs:{"src":require("../assets/img/colorado_sounds_1.jpg"),"alt":"Mountains"}}),_c('img',{staticClass:"img-2",attrs:{"src":require("../assets/img/colorado_sounds_2.jpg"),"alt":"Wood Storage"}})])])
}]

export { render, staticRenderFns }